import { Navigate } from "react-router-dom"

const ProtectedRoute = ({ children, isAuthenticated, access }) => {
  const user = JSON.parse(localStorage.getItem("user"))
  const userPermissions = user?.data?.user?.permissions || []
  const userRole = user?.data?.user?.role

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />
  }

  if (access === "platform") {
    if (!user?.data?.user?.isPlatformAdmin) {
      return <Navigate to="/unauthorized" replace />
    }
    return children
  }

  if (userPermissions.includes("*") || userRole === "network-admin") {
    return children
  }

  if (access) {
    const requiredAccess = Array.isArray(access) ? access : [access]
    const hasPermission = requiredAccess.some((accKey) =>
      userPermissions.some((perm) => {
        const baseKey = perm.split("/:")[0]
        const baseAcc = accKey.split("/:")[0]
        return perm === accKey || baseKey === baseAcc
      })
    )
    if (!hasPermission) {
      return <Navigate to="/unauthorized" replace />
    }
  }
  return children
}

export default ProtectedRoute
